import { HEADER } from "./constants";

export const toggleUserMenu = () => (dispatch) =>
  dispatch({ type: HEADER.TOGGLE_USER_MENU });

export const toggleCommonMenu = () => (dispatch) =>
  dispatch({ type: HEADER.TOGGLE_COMMON_MENU });

export const closeMenus = () => (dispatch) => dispatch({ type: HEADER.CLOSE_MENUS });
